import React from 'react';
import { useTranslation } from 'react-i18next';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

interface Props {
  code?: string;
  message?: string;
  translationNamespace?: string;
}

const PageError = ({ code, message, translationNamespace }: Props): JSX.Element => {
  const { t } = useTranslation([TranslationNamespaces.global, translationNamespace || '']);
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 8,
        textAlign: 'center',
      }}
    >
      <Typography variant='h2' style={{ fontWeight: 600 }}>
        {code}
      </Typography>
      {message && (
        <Typography variant='h5'>{t(translationNamespace ? `${translationNamespace}:${message}` : message)}</Typography>
      )}
      <Typography variant='subtitle1'>
        {t('contactAdmin')}{' '}
        <Link to='/' style={{ color: theme.palette.secondary.main }}>
          {t('home')}
        </Link>
        .
      </Typography>
    </div>
  );
};

export default PageError;
